import React from 'react';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Μαρία Παπαδοπούλου',
      position: 'Διευθύντρια και Δασκάλα Πιάνου',
      bio: 'Με πάνω από 15 χρόνια εμπειρίας στη μουσική εκπαίδευση, η Μαρία είναι αφοσιωμένη στην ανάπτυξη των μουσικών ταλέντων των μαθητών της. Σπούδασε στο Ωδείο Αθηνών και έχει κερδίσει πολλά βραβεία σε διεθνείς διαγωνισμούς πιάνου.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Ελένη Νικολάου',
      position: 'Δασκάλα Βιολιού',
      bio: 'Η Ελένη είναι μέλος της Κρατικής Ορχήστρας Αθηνών και διδάσκει βιολί εδώ και 12 χρόνια. Η προσέγγισή της συνδυάζει την κλασική τεχνική με σύγχρονες μεθόδους διδασκαλίας που κάνουν τη μάθηση διασκεδαστική.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Γιώργος Κωνσταντίνου',
      position: 'Δάσκαλος Κιθάρας',
      bio: 'Ο Γιώργος ειδικεύεται τόσο στην κλασική όσο και στην ηλεκτρική κιθάρα. Με πάθος για τη μουσική και 10 χρόνια εμπειρίας, έχει βοηθήσει εκατοντάδες μαθητές να ανακαλύψουν τη χαρά της κιθάρας.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Σοφία Μητροπούλου',
      position: 'Δασκάλα Φωνητικής',
      bio: 'Η Σοφία είναι πτυχιούχος της Εθνικής Λυρικής Σκηνής και έχει εμφανιστεί σε πολλές οπερατικές παραγωγές. Διδάσκει φωνητική με έμφαση στην υγιή τεχνική και την καλλιτεχνική έκφραση.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Δημήτρης Αλεξίου',
      position: 'Δάσκαλος Τυμπάνων και Θεωρίας',
      bio: 'Ο Δημήτρης έχει εργαστεί με πολλές γνωστές ελληνικές μουσικές ομάδες και διδάσκει τύμπανα και μουσική θεωρία. Η ενέργειά του και η αγάπη του για τη μουσική είναι μεταδοτικές.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div className="about-page">
      <div className="about-hero">
        <h1>Σχετικά με το Halecor</h1>
        <p>Η Μουσική Σχολή της Αριστείας</p>
      </div>

      <div className="about-content">
        <h2>Η Ιστορία μας</h2>
        <p>
          Το Halecor ιδρύθηκε το 2015 με όραμα να δημιουργήσει έναν χώρο όπου η μουσική 
          εκπαίδευση συναντά την καινοτομία και την αφοσίωση. Από την πρώτη μέρα, στόχος 
          μας ήταν να προσφέρουμε όχι απλώς μαθήματα μουσικής, αλλά μια ολοκληρωμένη 
          μουσική εμπειρία που εμπνέει και μεταμορφώνει.
        </p>
        <p>
          Με πάνω από μια δεκαετία εμπειρίας, έχουμε εκπαιδεύσει περισσότερους από 500 
          μαθητές, πολλοί από τους οποίους έχουν συνεχίσει επαγγελματικές καριέρες στη 
          μουσική. Η προσέγγισή μας συνδυάζει την παραδοσιακή μουσική παιδαγωγική με 
          σύγχρονες μεθόδους διδασκαλίας, δημιουργώντας ένα μοναδικό και αποτελεσματικό 
          μαθησιακό περιβάλλον.
        </p>

        <h2>Η Φιλοσοφία μας</h2>
        <p>
          Πιστεύουμε ότι η μουσική είναι μια καθολική γλώσσα που ενώνει τους ανθρώπους 
          και εμπλουτίζει τη ζωή. Η φιλοσοφία μας βασίζεται στην πεποίθηση ότι κάθε άτομο 
          έχει μουσικό ταλέντο που περιμένει να ανακαλυφθεί και να αναπτυχθεί. Δεν 
          διδάσκουμε απλώς νότες και τεχνικές, αλλά καλλιεργούμε την αγάπη για τη μουσική 
          και την καλλιτεχνική έκφραση.
        </p>
        <p>
          Κάθε μαθητής είναι μοναδικός και αντιμετωπίζεται ως τέτοιος. Προσαρμόζουμε τα 
          μαθήματά μας στις ανάγκες, τους στόχους και το ρυθμό μάθησης κάθε ατόμου, 
          εξασφαλίζοντας ότι όλοι έχουν την ευκαιρία να αριστεύσουν. Η επιτυχία των 
          μαθητών μας είναι η δική μας επιτυχία.
        </p>

        <h2>Τι μας Ξεχωρίζει</h2>
        <p>
          Το Halecor ξεχωρίζει για την ποιότητα της εκπαίδευσης, τις σύγχρονες 
          εγκαταστάσεις μας και την αφοσιωμένη ομάδα εκπαιδευτών μας. Διαθέτουμε πλήρως 
          εξοπλισμένες αίθουσες με υψηλής ποιότητας μουσικά όργανα και τεχνολογία που 
          υποστηρίζει τη μάθηση. Επιπλέον, οργανώνουμε τακτικές συναυλίες και εκδηλώσεις 
          που δίνουν στους μαθητές μας την ευκαιρία να παρουσιάσουν τις δεξιότητές τους 
          και να κερδίσουν σκηνική εμπειρία.
        </p>
      </div>

      <div className="team-section">
        <h2>Η Ομάδα μας</h2>
        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-member">
              <img 
                src={member.image} 
                alt={`Μέλος Ομάδας ${member.id}`} 
                width="400" 
                height="400" 
                className="team-photo"
              />
              <h3>{member.name}</h3>
              <p className="position">{member.position}</p>
              <p className="bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  
    </>);
}

export default About;